enum VideoProviderEnum {
  Youtube = 'youtube',
  Vimeo = 'vimeo',
}

export default VideoProviderEnum;
